export default "__VITE_ASSET__WnBgAf1F__"